/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPerson = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M15.695 8.53a3.999 3.999 0 1 0-7.39-3.06 3.999 3.999 0 0 0 7.39 3.06M5.113 14.188c.146-.714.768-1.714 1.714-1.714h10.335c.947 0 1.56 1.004 1.714 1.714L20.5 20h-17z" /></svg>;
export default SvgPerson;